/* global axios */
import ApiClient from './ApiClient';

class ConversationMeetingsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create(conversationId, record = true) {
    return axios.post(`${this.url}/${conversationId}/meetings`, { record });
  }
}

export default new ConversationMeetingsAPI();
